import React from "react";
import { FieldArrayWithId } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { BundleApi, BundleItemApi } from "../../../../../../../../../../../../services/Api/Organization/types";
import { areAllItemsRowsIndexesShown, toggleAllItemsRows } from "../../../../../../utils/itemsTableUtils";

interface Props {
	watchedItems: BundleItemApi[];
	shownIndexes: number[];
	setShownIndexes: (newIndexes: number[]) => void;
	fields: FieldArrayWithId<BundleApi, "items", "key">[];
}

const BundleFormItemsTableHeader = ({ shownIndexes, setShownIndexes, watchedItems, fields }: Props) => {
	const { t } = useTranslation();

	return (
		<thead>
			<tr>
				<th className="action" />
				<th style={{ minWidth: "300px" }}>
					{t("common.word.product")} *
					<a
						href="javascript:"
						onClick={() => toggleAllItemsRows(shownIndexes, watchedItems, setShownIndexes, fields)}
						className="ms-1 font-weight-normal"
					>
						{areAllItemsRowsIndexesShown(fields, shownIndexes)
							? t("common.action.collapse_all")
							: t("common.action.expand_all")}
					</a>
				</th>
				<th style={{ minWidth: "100px" }}>{t("common.word.quantity")} *</th>
				<th style={{ minWidth: "100px" }}>{t("modules.bundle.field.quantity_produced.title")} *</th>

				<th className="action" />
			</tr>
		</thead>
	);
};

export default BundleFormItemsTableHeader;
